/* istanbul ignore file */
import { ThemeProvider, EmotionCacheProvider } from '@ori-ui/mui';
import { parseClientAppConfig } from '@ori/client-app-config';
import { ErrorBoundary, LoggerProvider, ApplicationInsights, getClientApplicationInsightsConfig } from '@ori/logger';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { APP_NAME, EMOTION_CACHE_KEY } from './constants';
import { mainLogger, logDebug } from './logger';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * React app renderer that is used when app is used as a standalone app
 */
export async function render(rootElement) {
  // in case things are done the old way :)
  const separatedValues = {
    ...rootElement.dataset
  };
  // fix for selected language
  if (!separatedValues.currentLanguage) {
    logDebug('adding currentLanguage from document.documentElement.lang');
    separatedValues.currentLanguage = document.documentElement.lang;
  }
  // fix for static api url
  if (!separatedValues.staticApiUrl) {
    logDebug('adding default staticApiUrl');
    separatedValues.staticApiUrl = 'https://api-static.oriflame.com/';
  }
  const {
    config = JSON.stringify(separatedValues)
  } = rootElement.dataset;
  logDebug('config:', config);
  const clientAppConfig = parseClientAppConfig(config, ['currentLanguage', 'staticApiUrl', 'tenant']);

  // Initialize Application Insights in production
  if (process.env.NODE_ENV === 'production') {
    ApplicationInsights.initialize(getClientApplicationInsightsConfig());
  }
  createRoot(rootElement).render(/*#__PURE__*/_jsx(LoggerProvider, {
    logger: mainLogger,
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      areaName: `${APP_NAME}-boundary`,
      children: /*#__PURE__*/_jsx(EmotionCacheProvider, {
        cacheKey: EMOTION_CACHE_KEY,
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          children: /*#__PURE__*/_jsx(App, {
            ...clientAppConfig
          })
        })
      })
    })
  }));
}